/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  Action,
  DetailItemList,
  HStack,
  ICON_EMAIL_OUTLINE,
  ICON_PHONE_OUTLINE,
  Message,
  Popover,
  PopoverProps,
  Spacing,
  Stack,
  Text,
} from '@doveit/bricks';
import PopoverPreview from '../../../components/popover-preview/PopoverPreview';
import { Contact } from '../../../providers/api/dtos';
import PopoverPreviewSkeleton from '../../../components/popover-preview/PopoverPreview.skeleton';
import useContact from '../../hooks/use-contact/useContact';
import ContactAvatar from '../../components/contact-avatar/ContactAvatar';
import UserActions from '../../../components/user-actions/UserActions';
import * as styles from './ViewContactPopoverPreview.style';
import ViewContactAction from '../view-contact-action/ViewContactAction';

interface WithContact {
  contact: Contact,
  contactId?: never,
}

interface WithContactId {
  contactId: string,
  contact?: never,
}

interface BaseViewContactPopoverPreviewProps extends React.AriaAttributes {
  trigger: PopoverProps['trigger'],
  hideAction?: boolean,
}

export type ViewContactPopoverPreviewProps = BaseViewContactPopoverPreviewProps & (WithContact | WithContactId);

export const LOAD_CONTACT_ERROR_MESSAGE = 'Non è stato possibile caricare i dati del contatto';

const ViewContactPopoverPreview: React.FC<ViewContactPopoverPreviewProps> = ({
  contactId,
  contact: externalContact,
  trigger,
  ...rest
}) => {
  const {
    data: loadedContact,
    isLoading: isContactLoading,
    error: contactError,
  } = useContact(contactId);

  const contact = externalContact || loadedContact;

  return (
    <Popover
      trigger={trigger}
      hasArrow
      {...rest}
    >
      <div css={styles.wrapper}>
        {(isContactLoading && !contactError) && (
          <PopoverPreviewSkeleton />
        )}

        {(contactError) && (
          <Spacing padding={200}>
            <Message
              type="critical"
              message={LOAD_CONTACT_ERROR_MESSAGE}
            />
          </Spacing>
        )}

        {contact && (
          <PopoverPreview
            title={contact.name || 'Contatto'}
            details={contact.name && 'Contatto'}
            avatar={(
              <ContactAvatar size="L" />
            )}
          >
            <Stack gap={150}>
              <DetailItemList>
                {contact.phoneNumber && (
                  <DetailItemList.Item icon={ICON_PHONE_OUTLINE}>
                    <Text.Body>{contact.phoneNumber}</Text.Body>
                  </DetailItemList.Item>
                )}
                {contact.email && (
                  <DetailItemList.Item icon={ICON_EMAIL_OUTLINE}>
                    <Text.Body>{contact.email}</Text.Body>
                  </DetailItemList.Item>
                )}
              </DetailItemList>

              <HStack gap={75} wrap="nowrap">
                <div style={{ flex: 1 }}>
                  <ViewContactAction contactId={contact.id!}>
                    {({ onClick }) => (
                      <Action
                        size="S"
                        color="primary"
                        label="Visualizza"
                        aria-label="Vai alla pagina del contatto"
                        onClick={onClick}
                        expanded
                      />
                    )}
                  </ViewContactAction>
                </div>
                <UserActions user={contact} />
              </HStack>
            </Stack>
          </PopoverPreview>
        )}
      </div>
    </Popover>
  );
};

export default ViewContactPopoverPreview;
